<template>
    <button
        :class="newClass"
        :style="{ width: width, color: color, backgroundColor: backgroundColor }"
        :disabled="disabled"
        @click="e => !disabled && $emit('click', e)"
    >
        <slot />
    </button>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        inactiveColor: {
            type: Boolean,
            default: false
        },
        className: {
            type: String
        },
        size: {
            type: String,
            default: "m"
        },
        width: {
            type: String,
            required: false
        },
        color: {
            type: String,
            required: false
        },
        backgroundColor: {
            type: String,
            required: false
        },
        rounded: {
            type: Boolean,
            required: false,
            default: false
        },
        rounded100: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        newClass() {
            const { inactiveColor, className, size, rounded, rounded100 } = this;
            return [className, inactiveColor && "inactiveColor", size, rounded ? "rounded" : null, rounded100 ? "rounded100" : null];
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/themes";
button {
    border: none;
    color: #fff;
    background-color: $color2;
    border-radius: 4px;
    text-transform: uppercase;
    transition: opacity 0.3s ease;
    &:focus {
        outline: none;
    }
    // m, s, and l define the differents sizes for this button.
    // It works with props. default is m.
    &.m {
        min-width: 90px;
        padding: 10px 15px;
    }
    &.l {
        padding: 20px 25px;
    }
    &.s {
        padding: 5px 10px;
        font-size: 12px;
    }
    &.xs {
        font-size: 10px;
    }
    &.inactiveColor {
        background-color: grey !important;
    }
    &:disabled {
        background-color: grey;
        cursor: no-drop;
    }
    &:hover {
        opacity: 0.8;
    }

    &.rounded {
        border-radius: 2em !important;
    }

    &.rounded100 {
        border-radius: 100% !important;

        &.s {
            padding: 0;
            width: 26px;
            height: 26px;
        }
        &.m {
            min-width: auto;
            padding: 0;
            width: 32px;
            height: 32px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// ClientColorButton.vue?9c98898a